/**
 * Design px -> rem, against the app's 12px root.
 *
 * Only for the geometry @cowbell/ui does not own. Radii, spacing and colours
 * come from the platform's Mantine tokens (`var(--mantine-radius-md)`,
 * `var(--mantine-spacing-md)`, component props) so this page stays in step with
 * the rest of the console rather than carrying its own scale.
 */
export const rem = (value: number): string => `${value / 12}rem`;

/** Two-up split: a fixed search panel beside a map that takes the rest. */
export const SPLIT_COLUMNS = `${rem(380)} minmax(0, 1fr)`;

/** Initials for an avatar, from an agency or person name. */
export const initialsOf = (name?: string): string => {
  if (!name) {
    return '?';
  }
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
};
